import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
import { featuredTestimonial, testimonials, type Testimonial } from '../data/testimonials';
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: Testimonial) {
  return <article className="paper-card flex h-full flex-col rounded-sm border border-brand-gold/40 p-6 shadow-[0_10px_28px_rgba(44,38,32,0.07)] md:p-7" data-id="element-291" data-mp="3b146nhllnt7f">
      <div className="mb-4 flex items-center gap-3" data-id="element-292" data-mp="370akotrpwoh6">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-sm border border-brand-gold/55 bg-brand-surfaceLight font-serif font-bold text-brand-forest" data-id="element-293" data-mp="31zczs9fbpgbz">
          {initials}
        </div>
        <div data-id="element-294" data-mp="2s2rxvwylolcd">
          <div className="flex text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-295" data-mp="2s306vdrlr6ia">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-296" data-mp="qac393b1qh1z" />)}
          </div>
          <p className="mt-1 font-semibold text-brand-ink" data-id="element-297" data-mp="h67z23dntm9u">{name}</p>
          <p className="text-xs text-brand-muted" data-id="element-298" data-mp="h816vm00ecjf">
            {location} · {product}
          </p>
        </div>
      </div>
      <p className="font-display text-base leading-relaxed text-brand-text md:text-lg" data-id="element-299" data-mp="77s9i4ua6l2g">
        “{text}”
      </p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pt-6" data-id="element-300" data-mp="c8y1u1k146bg">
      <div className="mx-auto max-w-3xl" data-id="element-301" data-mp="zwpljq7wflmr">
        <TestimonialCard {...featuredTestimonial} data-id="element-302" data-mp="zwy33veyvf4a" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section data-id="element-303" data-mp="14xlpu4w5x9sp">
      <SectionHeading character="證" className="mb-10" data-id="element-304" data-mp="q6mlx769v9fg">
        LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
      </SectionHeading>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-305" data-mp="v4xwjk4e5nyq">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-306" data-mp="1iu8yv61e3qez" />)}
      </div>
    </Section>;
}